/* eslint-disable @typescript-eslint/no-explicit-any */
import { FluentProvider, webDarkTheme, webLightTheme, Theme } from '@fluentui/react-components';
import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { azureDevOpsOverrides } from './dark-theme-overrride';

const darkTheme: Theme = {
	...webDarkTheme,
	...azureDevOpsOverrides
};

type Props = {
  children?: ReactNode | Iterable<ReactNode>;
}

interface ThemeContextType {}

const ThemeContext = createContext({}  as ThemeContextType);
export const useThemeProvider = () => useContext(ThemeContext);

export default function ThemeProvider(props: Props) {
	const [theme, setTheme] = useState(webLightTheme);

	useEffect(() => {
		const isDarkMode = (ev: any) => {
			const bgColor = ev.detail['palette-neutral-0'];
			return bgColor.replace('rgba(', '').replace(/\s/gm, '').split(',')[0] !== '255';
		};

		const azureThemHandler = (ev: any) => {
			if (isDarkMode(ev)) {
				setTheme(darkTheme);
			} else {
				setTheme(webLightTheme);
			}
		};

		window.addEventListener('themeApplied', azureThemHandler);
		return () => {
			window.removeEventListener('themeApplied', azureThemHandler);
		};
	}, []);

	return (
		<ThemeContext.Provider value={{}}>
			<FluentProvider theme={theme}>
				{props?.children}
			</FluentProvider>
		</ThemeContext.Provider>
	);
}